var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_18353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94591 0.5C11.0179 0.5 11.5539 1.2296 11.5539 2.0656C11.5539 3.1096 10.6227 4.0752 9.41071 4.0752C8.39551 4.0752 7.80351 3.4752 7.83151 2.4832C7.83151 1.6488 8.53631 0.5 9.94591 0.5ZM6.64751 16.5C5.80111 16.5 5.18111 15.9784 5.77311 13.6808L6.74431 9.6072C6.91311 8.956 6.94111 8.6944 6.74431 8.6944C6.49071 8.6944 5.39311 9.144 4.74271 9.588L4.32031 8.884C6.37791 7.1352 8.74511 6.1104 9.76111 6.1104C10.6067 6.1104 10.7475 7.1288 10.3251 8.6944L9.21231 12.976C9.01551 13.732 9.09951 13.9928 9.29711 13.9928C9.55071 13.9928 10.3827 13.6792 11.2003 13.0272L11.6803 13.6784C9.67871 15.716 7.49231 16.5 6.64751 16.5Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_18353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.6f5b7abd90d73ac70c8854ef346ce29c.svg";
export { ForwardRef as ReactComponent };